// extracted by mini-css-extract-plugin
export default {"card":"styles_card__GEKGg","container":"styles_container__sdDXb","list":"styles_list__Y+Gh+"};